
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2a10 10 0 1010 10A10.016 10.016 0 0012 2zm-.75 6a.75.75 0 011.5 0v5a.75.75 0 01-1.5 0zm1.67 8.38a1.032 1.032 0 01-.21.33 1.155 1.155 0 01-.33.21.943.943 0 01-.76 0 1.155 1.155 0 01-.33-.21 1.032 1.032 0 01-.21-.33.942.942 0 010-.76.9.9 0 01.54-.54 1 1 0 01.76 0 .9.9 0 01.54.54.942.942 0 010 .76z","fill":"#292d32","data-name":"vuesax/bold/info-circle"}})])
          )
        }
      }
    